(function () {
    'use strict';

    angular
        .module('vobeApp')
        .factory('ShoppingCartAddRecipients', ShoppingCartAddRecipients);

    ShoppingCartAddRecipients.$inject = ['$resource'];

    function ShoppingCartAddRecipients ($resource) {
        var service = $resource('api/shoppingcart/addRecipients', {}, {
            'add': {
                method: 'PUT',
                transformResponse: function (data) {
                    if(!data || (typeof data === 'string' && data.length==0)){
                        return data;
                    }
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });

        return service;
    }
})();
